/**
 * Whether two arrays hold the same members in the same places, compared by identity.
 *
 * For deciding whether a derived value can be handed back unchanged. The members are what a consumer
 * keys off, so comparing them by reference answers the whole question, and nothing inside a member is
 * read: the cost is the length of the array, whatever the members hold.
 */
export const equalsShallow = <TItem>(left: readonly TItem[], right: readonly TItem[]): boolean =>
    left.length === right.length && left.every((item, index) => item === right[index]);
